import axios from "axios";
import React, { useContext, useEffect, useState } from "react";
import { ContextData } from "../../context/Context";
import AlertPOP from "../../routes/AlertPOP";
import Loader from "../../routes/Loader";
import { FaUser, FaLock } from "react-icons/fa"; // Import icons
import { toast } from "react-toastify";
import { Postrequest } from "../../context/AxiosRequest";
import { useNavigate } from "react-router-dom";
import  jwtDecode  from "jwt-decode";
import GetAdminCredentials from "../../context/GetAdminCredentials";



// Scholarship Captions
const captions = [
  "📚 Unlock your future with our scholarships!",
  "🎓 Invest in your education today.",
  "💡 Empowering students, one scholarship at a time.",
  "🌍 Your dreams deserve a chance. Apply now!",
  "🚀 Education is the key to a brighter future."
];

function Login() {


  const [Username, setUsername] = useState("");
  const [Password, setPassword] = useState("");
  const { setUserTokens, setaccesstoken } = useContext(ContextData);
  const [message, setMessage] = useState("");
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [captionIndex, setCaptionIndex] = useState(0);
  const Navigate = useNavigate() 
    const  user_roles = [
           "Administrator",
          "Manage",
          "Selector",
          "Validator",
          "Verifier",
          "Bank reviewer",
          "account-helper",
          "Manage Loan",
          "Manage Scholarship",
          "Manage Loan General"
           ]

  // Caption Slider Effect
  useEffect(() => {
    const interval = setInterval(() => {
      setCaptionIndex((prev) => (prev + 1) % captions.length);
    }, 3000); // Change caption every 3 seconds
    return () => clearInterval(interval);
  }, []);

  const handleClick = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const HandleSubmit = async(e) => {

    e.preventDefault();
   // handleClick();

    if (Username.trim() === "" || Password.trim() === "") {
    //  setMessage("⚠️ No empty input allowed");
      toast.error("⚠️ No empty input allowed");
      return;
    }

    setLoading(true);
    
    const data = { email: Username, passwrd: Password };

      const response = await Postrequest('/pub/admin_u_login',data,"no")

        if (response.status) {

         const decode = await jwtDecode(response.accesstoken)

          if(decode){

                GetAdminCredentials(decode.usertoken,response.accesstoken).then(res =>{
                  
                  setUserTokens(decode.usertoken) 
                  setaccesstoken(response.accesstoken)

                 

     
                  if(user_roles.includes(res[0].acct_typ)){

                            Navigate("/dashboard")
        
                  }
                  
                  
                if(user_roles[9] === res[0].acct_typ){

                            Navigate("/loan_general")
        
                  }
                  
                  if(user_roles[7] === res[0].acct_typ){

                            Navigate("/loan_manage")
        
                  }

                     
                  if(user_roles[4] === res[0].acct_typ){

                            Navigate("/verifier_loan")
        
                  }



               
                  

                     

                        
                        
            })
                    
                    
               
            

                    
                    
                    }

                 
                      

        }
        else {
          toast.error(response.text);
        }
        setLoading(false);
 
  };

  return (
    <div className="h-screen w-full flex flex-col md:flex-row bg-gradient-to-r from-blue-900 to-blue-600">
      <AlertPOP Open={open} handleClose={handleClose} message={message} />
      <Loader />

      {/* Left Side - Caption Slider (50% Width) */}
      <div className="w-full md:w-1/2 flex flex-col items-center justify-center text-white px-10 text-center">
        <h1 className="text-5xl font-bold mb-6">Scholarship and Tertiary Education Loans Portal</h1>
        <p key={captionIndex} className="text-2xl font-semibold transition-shadow  duration-1000 ease-in-out">
          {captions[captionIndex]}
        </p>
      </div>

      {/* Right Side - Login Form (50% Width) */}
      <div className="w-full md:w-1/2 flex flex-col items-center justify-center">
        <div className="bg-white/10 backdrop-blur-md p-10 rounded-lg shadow-lg w-96 flex flex-col items-center text-white">
          <h1 className="text-4xl font-bold mb-6">Login</h1>

          <form className="w-full flex flex-col" onSubmit={HandleSubmit}>
            <div className="relative mb-6">
              <FaUser className="absolute left-3 top-4 text-gray-300 text-2xl" />
              <input
                type="email"
                placeholder="Email"
                className="w-full pl-12 py-3 text-lg rounded-md bg-white/20 border-none outline-none text-white placeholder-gray-300"
                value={Username}
                onChange={(e) => setUsername(e.target.value)}
              />
            </div>

            <div className="relative mb-6">
              <FaLock className="absolute left-3 top-4 text-gray-300 text-2xl" />
              <input
                type="password"
                placeholder="Password"
                className="w-full pl-12 py-3 text-lg rounded-md bg-white/20 border-none outline-none text-white placeholder-gray-300"
                value={Password}
                onChange={(e) => setPassword(e.target.value)}
              />
            </div>

            <button
              type="submit"
              className="w-full py-3 text-lg bg-blue-500 rounded-md hover:bg-blue-700 transition-all text-white font-bold"
              disabled={loading}
            >
              {loading ? "Logging in..." : "Login"}
            </button>
          </form>
        </div>
      <p className='text-center text-white mt-2 font-extrabold text-xs'>Powered By MastermindTech</p>
      </div>
    </div>
  );
}

export default Login;
